// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"364":"28aea99d37452773bd04","961":"f1f598959ac8560fed3a","2648":"dc5efcbfd8d2d4085f3e","6540":"9f053fb0eab718712e45"}[chunkId] + ".js";
};